import { makeStyles } from '@material-ui/core/styles'
import PlayCircleFilledIcon from '@material-ui/icons/PlayCircleFilled'
import clsx from 'clsx'
import React from 'react'

const useMediaStyles = makeStyles({
    playIcon: {
        position: 'absolute',
        color: '#ffffffaa',
    },
    videoOverlayContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    overlay: {
        background: 'rgba(0,0,0,0.15)',
        position: 'absolute',
    },
    mediaItem: {
        objectFit: 'cover',
    },
})

export interface VideoOverlayProps {
    /**
     *  Video still image full path.
     */
    src?: string

    /**
     *	Classname intended for being targeted
     *  by automated tests.
     */
    className?: string

    /**
     * 	Image width
     */
    width?: string | number

    /**
     * 	Image height
     */
    height?: string | number

    /**
     * Enables/Disables full overlay.
     *
     * The full overlay is used in ProductListingCard carousel.
     */
    hasFullOverlay?: boolean
}

/**
 *	This component injects a "play button" overlay
 * 	to the provided image.
 */
const VideoOverlay: React.FC<VideoOverlayProps> = ({
    src,
    className,
    width,
    height,
    hasFullOverlay = false,
}) => {
    const classes = useMediaStyles()
    return (
        <div className={clsx(classes.videoOverlayContainer, className)}>
            <PlayCircleFilledIcon
                fontSize="large"
                className={clsx(classes.playIcon, 'playIconOverlay')}
            />
            {hasFullOverlay && (
                <div
                    style={{ height: height, width: width }}
                    className={clsx(classes.overlay, 'imageOverlay')}
                />
            )}
            <img
                className={classes.mediaItem}
                style={{ height: height, width: width }}
                src={src}
                alt="Video clip overlay"
            />
        </div>
    )
}

export default VideoOverlay
